var $32dbb2511b94a9ec$exports = {};
const $32dbb2511b94a9ec$var$CARD = {
    R: 18,
    GAP: 16
};
let $32dbb2511b94a9ec$var$vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
let $32dbb2511b94a9ec$var$vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
function $32dbb2511b94a9ec$var$buildRectPath(W, H, R) {
    return [
        `M ${R} 0`,
        `L ${W - R} 0`,
        `A ${R} ${R} 0 0 1 ${W} ${R}`,
        `L ${W} ${H - R}`,
        `A ${R} ${R} 0 0 1 ${W - R} ${H}`,
        `L ${R} ${H}`,
        `A ${R} ${R} 0 0 1 0 ${H - R}`,
        `L 0 ${R}`,
        `A ${R} ${R} 0 0 1 ${R} 0 Z`
    ].join(' ');
}
function $32dbb2511b94a9ec$var$getCardConfig(W) {
    if (W < 640) return {
        R: 10,
        GAP: 0,
        mapWidthRatio: 0.95,
        mapHeightRatio: 1,
        notch: false
    };
    if (W < 900) return {
        R: 18,
        GAP: 16,
        mapWidthRatio: 0.5,
        mapHeightRatio: 0.5,
        notch: true
    };
    return {
        R: 18,
        GAP: 16,
        mapWidthRatio: 0.5,
        mapHeightRatio: 0.5,
        notch: true
    };
}
function $32dbb2511b94a9ec$var$buildPath(W, H, CARD) {
    const cfg = $32dbb2511b94a9ec$var$getCardConfig(W);
    const MAP_W = W * cfg.mapWidthRatio - cfg.GAP;
    const MAP_H = Math.min(W * cfg.mapHeightRatio * 34 / 45 - cfg.GAP, H - cfg.GAP * 2);
    const MAP_LEFT = W - MAP_W;
    if (!cfg.notch) // Mobile: simple rounded rect, no notch geometry needed
    return {
        d: $32dbb2511b94a9ec$var$buildRectPath(W, H, cfg.R),
        MAP_W: MAP_W,
        MAP_H: MAP_H,
        MAP_LEFT: MAP_LEFT
    };
    const NOTCH_X = MAP_LEFT - cfg.GAP;
    const NOTCH_Y = MAP_H + cfg.GAP;
    const d = [
        `M ${cfg.R} 0`,
        `L ${NOTCH_X - cfg.R} 0`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${NOTCH_X} ${cfg.R}`,
        `L ${NOTCH_X} ${NOTCH_Y - cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 0 ${NOTCH_X + cfg.R} ${NOTCH_Y}`,
        `L ${W - cfg.R} ${NOTCH_Y}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${W} ${NOTCH_Y + cfg.R}`,
        `L ${W} ${H - cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${W - cfg.R} ${H}`,
        `L ${cfg.R} ${H}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 0 ${H - cfg.R}`,
        `L 0 ${cfg.R}`,
        `A ${cfg.R} ${cfg.R} 0 0 1 ${cfg.R} 0 Z`
    ].join(' ');
    return {
        d: d,
        MAP_W: MAP_W,
        MAP_H: MAP_H,
        MAP_LEFT: MAP_LEFT
    };
}
const $32dbb2511b94a9ec$var$appdDemo = document.querySelector('.app-demo');
const $32dbb2511b94a9ec$var$containerHeader = document.getElementById('s-header-container');
const $32dbb2511b94a9ec$var$cardContent = document.querySelector('.tracker-peack');
const $32dbb2511b94a9ec$var$cardRoot = document.querySelector('.mln-card-root');
const $32dbb2511b94a9ec$var$viewbox = document.querySelector('.viewbox');
let $32dbb2511b94a9ec$var$prevIsMobile = null;
function $32dbb2511b94a9ec$var$reparentMapCard(isMobile) {
    if (isMobile === $32dbb2511b94a9ec$var$prevIsMobile) return;
    $32dbb2511b94a9ec$var$prevIsMobile = isMobile;
    if (isMobile) {
        $32dbb2511b94a9ec$var$appdDemo.style.position = 'static';
        $32dbb2511b94a9ec$var$appdDemo.style.alignSelf = 'center';
        $32dbb2511b94a9ec$var$appdDemo.style.background = "none";
        $32dbb2511b94a9ec$var$appdDemo.style.boxShadow = "none";
        $32dbb2511b94a9ec$var$cardContent.style.width = '100%';
        $32dbb2511b94a9ec$var$cardContent.insertBefore($32dbb2511b94a9ec$var$appdDemo, $32dbb2511b94a9ec$var$cardContent.children[1]);
    } else {
        $32dbb2511b94a9ec$var$cardRoot.appendChild($32dbb2511b94a9ec$var$appdDemo);
        $32dbb2511b94a9ec$var$appdDemo.style.position = 'absolute';
        $32dbb2511b94a9ec$var$appdDemo.style.background = "linear-gradient(45deg, #ecf0f2 0%, #f7f8f9 100%)";
        $32dbb2511b94a9ec$var$appdDemo.style.boxShadow = "-8px -8px 20px var(--shadow-light), 8px 8px 20px var(--shadow-dark), inset -5px -5px 15px var(--shadow-light), inset 5px 5px 10px #aeaec040";
        $32dbb2511b94a9ec$var$cardContent.style.width = "calc(50% - 32px)";
    }
}
function $32dbb2511b94a9ec$var$applyGeometry(W, H) {
    const { d: d, MAP_W: MAP_W, MAP_H: MAP_H, MAP_LEFT: MAP_LEFT } = $32dbb2511b94a9ec$var$buildPath(W, H, $32dbb2511b94a9ec$var$CARD);
    // L-card clip
    const mlnCard = document.getElementById('mlnCard');
    // if (mlnCard) mlnCard.style.clipPath = `path("${d}")`;
    // Single SVG path — convex-bubble filter only
    const shadowPath = document.getElementById('insetLightPath');
    if (shadowPath) shadowPath.setAttribute('d', d);
    // SVG canvas sizing
    const svg = document.getElementById('mlnf-inset-svg');
    if (svg) {
        svg.setAttribute('width', W);
        svg.setAttribute('height', H);
    }
    // Map card position + size
    const map = document.querySelector('.app-demo');
    if (map) {
        map.style.left = `${MAP_LEFT}px`;
        map.style.width = `${MAP_W}px`;
        map.style.height = `${MAP_H}px`;
    }
    if ($32dbb2511b94a9ec$var$cardContent) {
        const headerH = $32dbb2511b94a9ec$var$containerHeader ? $32dbb2511b94a9ec$var$containerHeader.getBoundingClientRect().height : 0;
        $32dbb2511b94a9ec$var$cardContent.style.minHeight = `${Math.max(0, MAP_H - headerH)}px`;
    }
}
const $32dbb2511b94a9ec$var$ro = new ResizeObserver((entries)=>{
    const { width: width, height: height } = entries[0].contentRect;
    const isMobile = width < 640; // stays in sync with getCardConfig's own threshold
    $32dbb2511b94a9ec$var$reparentMapCard(isMobile);
    $32dbb2511b94a9ec$var$applyGeometry(width, height); // always runs now
});
$32dbb2511b94a9ec$var$ro.observe($32dbb2511b94a9ec$var$cardRoot);


//# sourceMappingURL=services.ce3a8f79.js.map
